/* eslint-disable */
import React from 'react';
import { Container, Col, Row, Card, Spacer } from '@cleartrip/bento';

import { ReactComponent as CTLogoOld } from 'assets/logos/cleartrip-old-logo.svg';
import { ReactComponent as Flight } from 'assets/icons/flight.svg';
import { ReactComponent as Hotel } from 'assets/icons/hotel.svg';

function Header({ additionalTabs = '', isRTL = false }) {
	const isInDomain = false;
	if(!isInDomain){
		const link = document.querySelector("link[rel~='icon']");
		link.href = 'https://www.cleartrip.ae/favicon.ico';
	}
	
	return (
		
		<header className={`bb bc-neutral-100 ${isRTL ? 'direction-rtl' : ''}`}>
			<Container>
				<Row className='flex-between'>
					<Col className=' d-none--xs'>
						<Card className='h-11 pt-4 pb-3 flex-middle flex'>
							<a href='/'>
							<CTLogoOld width={107} height={23} />
							</a>
							<Spacer mr={13} />
							<a href='/flights'>
								<Flight width={18} height={18} />
							</a>
							<Spacer className='pr-6' />
							<a href='/hotels'>
								<Hotel />
							</a>
							<Spacer className='pr-6' />
						</Card>
					</Col>
					{additionalTabs && (
						<Col className="d-none--xs">
							<Card className='flex flex-middle flex-right h-11 pt-4 pb-4'>{additionalTabs}</Card>
						</Col>
					)}

					<Col className='d-none d-block--xs'>
						<Card className='flex flex-center flex-middle h-11'>
							<a href='/'>
								<CTLogoOld width={107} height={23} />
							</a>
						</Card>
					</Col>
				</Row>
			</Container>
		</header>
	);
}

export default Header;
